export const skeletonGenerator = (skeleton, count = 10) => {
  const skeletons = [];
  for (let i = 0; i < count; i++) {
    skeletons.push(<div key={i}>{skeleton}</div>);
  }
  return skeletons;
};
